import { API_COMPOSER_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type {
  Error,
  GetRunnerRunSelectedStepsTestConfigsResponse,
  GetRunnerRunSelectedStepsTestConfigsResponseQuery
} from '@eggplant/types'
import type { ReactNode } from 'react'

interface Props {
  testConfigId: string
  onSuccess?: (response: GetRunnerRunSelectedStepsTestConfigsResponse) => void
  onError?: (error: Error) => void
  children?: (response: GetRunnerRunSelectedStepsTestConfigsResponse) => ReactNode
  spinnerSize?: number
  params?: GetRunnerRunSelectedStepsTestConfigsResponseQuery
}

const GetComposerTestConfigSteps = ({
  testConfigId,
  onSuccess,
  onError,
  children,
  spinnerSize,
  params
}: Props) => {
  const url = `${API_COMPOSER_SERVICE}/runner/test_configurations/${testConfigId}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      params={params}
      spinnerSize={spinnerSize}
      url={url}
    />
  )
}

export default GetComposerTestConfigSteps
